import type { IFontData2 } from '../../../uiParts/fontData2'
import { fontData2 } from '../../../uiParts/fontData2-sidecar'

export interface IGolfFonts {
  f: IFontData2
  fBubble: IFontData2
}

let _obj: IGolfFonts | null = null
export function get() {
  if (!_obj) {
    _obj = {
      f: fontData2.loadConvertedFont('fontPoppins'),
      fBubble: fontData2.loadConvertedFont('fontPoppinsBubble'),
    }
  }
  return _obj
}
